import { gql } from "@/__generated__/gql";

export const RISE_MELT_SCORE_TIME_SERIES = gql(`
  query riseMeltScoreTimeSeries($orgId: ID!, $userId: ID!) {
    node(id: $userId) {
      id
      ... on Student {
        __typename
        rise {
          meltScoreTimeSeries(organizationId: $orgId) {
            date
            value
            index
          }
        }
      }
    }
  }
`);
